import React from 'react'
import {AppBar, Toolbar, Grid, Hidden, IconButton} from '@mui/material';
import CustomTabs from './CustomTabs';
import {MdOutlineManageSearch} from "react-icons/md";
import Accessibility from "../Accessibility";
import Languages from "../Languages";

const headerStyles = {
    appBar: {
        backgroundColor: '#F7F2F9',
        boxShadow: '0 2px 8px rgba(103, 80, 164, 0.12)',
        borderBottom: '1px solid #E8DEF8'
    },
    toolbar: {
        padding: '0.5rem 2rem',
        minHeight: '64px'
    },
    logoContainer: {
        width: 70,
        transition: 'transform 0.2s ease',
        '&:hover': {
            transform: 'scale(1.05)'
        }
    },
    iconButton: {
        color: '#49454F',
        transition: 'all 0.2s ease',
        '&:hover': {
            color: '#6750A4',
            backgroundColor: 'rgba(103, 80, 164, 0.08)'
        }
    },
    utilityBar: {
        display: 'flex',
        alignItems: 'center',
        gap: '0.25rem'
    }
};

//Navigation header/menu
const NavMenu = ({routes, children}) => {
    return (
        <AppBar position="static" color="inherit" elevation={0} sx={headerStyles.appBar}>
            <Toolbar sx={headerStyles.toolbar}>
                <Grid container alignItems="center" justifyContent="space-between" wrap="nowrap">
                    {/* Logo on the left */}
                    <Grid item sx={headerStyles.logoContainer}>
                        <a href={'/'} style={{display: 'block'}}>
                            <img src={'vividKidsLogo.svg'} alt="VividKids" style={{display: 'block'}}/>
                        </a>
                    </Grid>

                    {/* Tabs in the center */}
                    <Grid item sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
                        <CustomTabs routes={routes}/>
                    </Grid>

                    {/* Utilities and dropdown on the right */}
                    <Grid item sx={headerStyles.utilityBar}>
                        <Accessibility/>
                        <Languages/>
                        <IconButton sx={headerStyles.iconButton}>
                            <MdOutlineManageSearch size={22}/>
                        </IconButton>
                        <Hidden smDown>
                            {children}
                        </Hidden>
                    </Grid>
                </Grid>
            </Toolbar>
        </AppBar>
    );
}

export default NavMenu
